import { createContext } from 'react';

// Inline connection editors put their navigation and actions in the host modal.
// Keeping the footer outside the scroll area also avoids nested scroll panels.
export const ChannelModalContext = createContext(null);
